import { Container, Text } from "@chakra-ui/react"

export function StaticBanner() {
  return (
    <Container
      minW="full"
      backgroundColor="#f77f00"
      height="fit-content"
      margin={0}
      position="sticky"
      top={0}
      zIndex={2}
      display="flex"
      alignItems="center"
      justifyContent="center"
      p={{base: 8, md: "unset"}}
    >
      <Text>ACHTUNG: DU BEFINDEST DICH AUF DEM TESTSYSTEM!</Text>
    </Container>
  )
}

export default StaticBanner
